import styled from 'styled-components';

export const ServiceOSLoginWrapper = styled.div`
  .accounts-menu-list-wrapper {
    width: 330px !important;
  }
  .not-logged-content .has-account-section {
    border: none !important;
  }

  .not-logged-content .has-account-section .click-to-login {
    font-weight: 400 !important;
    border-radius: 20px !important;
    height: 40px !important;
    width: 100% !important;
  }
  .not-logged-content .no-account-section .click-to-register {
    font-size: 14px !important;
    font-weight: 300 !important;
  }

  .not-logged-content .no-account-section .click-to-register span {
    font-weight: 300 !important;
    text-decoration: underline !important;
    text-decoration-thickness: 1px !important;
    text-underline-offset: 2px !important;
  }

  .not-logged-content .no-account-section {
    background-color: white !important;
    padding-top: 4px;
    padding-bottom: 20px;
  }

  .logged {
    width: 252px !important;
  }

  .acc-avatar {
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    width: 32px !important;
    height: 32px !important;
    font-size: 14px !important;
    font-weight: 400 !important;
    font-family: 'Roboto', sans-serif !important;
    margin-right: 10px !important;
  }

  .menu-arrow {
    background-color: #000000 !important;
  }

  .menu-arrow:before {
    width: 1.5px !important;
    height: 6px !important;
  }
  .menu-arrow:after {
    width: 1.5px !important;
    height: 6px !important;
  }

  .accounts-menu-list ul {
    border: none !important;
    border-radius: none !important;
  }

  .accounts-menu-list ul li a span.menu-item-icon {
    background-size: contain !important;
    background-position: center !important;
    background-repeat: no-repeat !important;
  }

  .accounts-menu-list ul li a {
    padding: 14px 24px !important;
    width: 100% !important;
    border-bottom: 1px solid #f5f5f3 !important;
  }
  .accounts-menu-list ul li {
    display: flex !important;
    align-items: center !important;
    border-bottom: none !important;
  }
  .accounts-menu-list ul {
    display: flex !important;
    flex-direction: column !important;
  }

  .accounts-menu-list {
    border-radius: 8px !important;
    border: solid 1px #e0e0df !important;
    box-shadow: 0px 0px 12px 0px #2b2b2b26 !important;
    overflow: hidden !important;
  }
  /* Outer triangle (border) */
  .accounts-menu-list::before {
    content: '' !important;
    position: absolute !important;
    top: -11.5px !important;
    right: 13px;
    width: 0 !important;
    height: 0 !important;
    border-left: 12px solid transparent !important;
    border-right: 12px solid transparent !important;
    border-bottom: 12px solid #e0e0df !important;
  }

  /* Inner triangle (fill) */
  .accounts-menu-list::after {
    content: '' !important;
    position: absolute !important;
    top: -10px !important;
    right: 13.5px;
    width: 0 !important;
    height: 0 !important;
    border-left: 11.5px solid transparent !important;
    border-right: 11.5px solid transparent !important;
    border-bottom: 11.5px solid #fff !important;
  }

  .accounts-menu-list ul li a span.menu-item-title {
    font-size: 16px !important;
    font-weight: 300 !important;
    color: #000000 !important;
  }

  .not-logged-content .has-account-section .title {
    font-size: 16px !important;
    font-weight: 400 !important;
    margin-bottom: 16px !important;
  }

  margin-right: 24px !important;

  @media screen and (max-width: 1200px) {
    margin-right: 0px !important;
    .wrap-element span {
      margin-left: 0px !important;
      margin-right: 0px !important;
    }
    .acc-avatar {
      width: 40px !important;
      height: 40px !important;
      font-size: 16px !important;
      font-weight: 400 !important;
    }
  }
`;
